try {
    if (process.env.TOKENS_FEATURE_FLAG === 'true' || process.env.STORYBOOK_TOKENS_FEATURE_FLAG !== 'false') require('./index-new.css');
    else require('./index.css');
  } catch (e) {
    if (e.code !== 'MODULE_NOT_FOUND') {
      throw e; // Re-throw unexpected errors
    }
    console.warn('index.css / index-new.css not found, proceeding without it.');
  }


import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';

const Loader = forwardRef(({ size = 'l', weight = 'bold', className }, ref) => (jsx("div", { ref: ref, className: classNames('cds-loader', `cds-loader--size-${size}`, `cds-loader--weight-${weight}`, className) })));

export { Loader };
